import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'

export const site: ContainerModuleLoader = (_bind) => {}

export * from './symbols'
export * from './types'
